import { BaseService } from '@/modules/Core/services/BaseService'
import type { ICitaCuentaPaquete, ICitaFacturaElectronica } from '@/modules/Financiera/interfaces'
import type { IResponseApi, IResponseApiSearch } from '@/modules/Core/interfaces/api/IApis'
import type { AxiosResponse } from 'axios'
import type { ICitaItemFactura } from '@/modules/Financiera/interfaces/tablas/ICitaItemFactura'
import type { IDetalleNotaCreditoCuenta } from '@/modules/Financiera/interfaces/INotaCreditoCuenta'
export class FacturaService extends BaseService<ICitaFacturaElectronica> {
  constructor() {
    super({
      baseUrl: 'financiera/facturas/'
    })
  }
  async invoiceItems(params: Record<string, unknown>): Promise<AxiosResponse<IResponseApiSearch<ICitaCuentaPaquete[]>>> {
    return this.http.get<IResponseApiSearch<ICitaCuentaPaquete[]>>(`/invoices-items`,{ params })
  }
  async getLastInfoInvoice(ciccId: number | string): Promise<AxiosResponse<IResponseApi<ICitaItemFactura>>> {
    return this.http.get<IResponseApi<ICitaItemFactura>>(`/get-last-invoice/${ciccId}`)
  }
  async notaCredito(facturaId: number): Promise<AxiosResponse<IResponseApi<IDetalleNotaCreditoCuenta>>> {
    return this.http.get<IResponseApi<IDetalleNotaCreditoCuenta>>(`/nota-credito/${facturaId}`)
  }
}
